<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">社團指導老師</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Property" id="Property" label="屬性" @change="propertyChange">
                    <div is="option" value="">全部</div>
                    <div is="option" v-for="item in Propertys" :key="item.key" :value="item.key">{{item.value}}</div>
                </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.CommunityID" id="CommunityID" label="社團" @change="communityChange" required>
                    <div is="option" value="">請選擇</div>
                    <div is="option" v-for="item in CommunitysFilter" :key="item.key" :value="item.key">{{item.value}}</div>
                </form-select>
            </div>
            <div class="col-12">
                <form-select v-model="vm.Group" id="Group" label="組別">
                    <div is="option" value="">無</div>
                    <div is="option" v-for="(item,index) in vm.Groups" :key="index" :value="item">{{item}}</div>
                </form-select>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Teacher" id="Teacher" label="指導老師(校內請輸入工號，校外請輸入姓名)" type="text" required></form-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'communityteacherDetail',
        api: '/api/communityteacher/',
        data: { Propertys: [], Communitys: [] },
        vm: { Property: "", Groups: [] },
        created: function () {
            this.$parameter.communityproperty().then((res) => { this.Propertys = res.data; });
            this.$parameter.community().then((res) => { this.Communitys = res.data; });
        },
        showntransform: function (data) {
            data = JSON.parse(data);
            if (data.Groups) {
                data.Groups = data.Groups.split(',');
            }
            return data;
        },
        computed: {
            CommunitysFilter: function () {
                return this.vm.Property == "" ? this.Communitys : this.Communitys.filter(x => x.Property == this.vm.Property);
            }
        },
        methods: {
            propertyChange: function () {
                this.vm.CommunityID = "";
            },
            communityChange: function () {
                let community = this.Communitys.find(x => x.key == this.vm.CommunityID);
                this.vm.Groups = [];
                if (community && community.Group) {
                    this.vm.Groups = community.Group.split(',');
                }
            }
        },
    });
</script>

<style>
</style>